import {FileDiffIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {useReviewers} from '../../data/use-reviewers'
import {CompletedReviewRow} from './shared/CompletedReviewRow'
import {buildReviewHeaderContent} from './shared/build-review-header-content'

export function ChangesRequested() {
  const {data: reviewers} = useReviewers()

  const changesRequestedReviews =
    reviewers.completedReviews?.filter(review => review.state === 'changes_requested') ?? []

  if (changesRequestedReviews.length === 0) {
    return null
  }

  const {title, description} = buildReviewHeaderContent(changesRequestedReviews, 'changes_requested')

  return (
    <ForYouItem
      icon={FileDiffIcon}
      title={title}
      itemName="changes-requested"
      variant="danger"
      description={description}
    >
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul className="list-none p-0" role="list">
        {changesRequestedReviews.map(review => (
          <CompletedReviewRow key={review.id} review={review} />
        ))}
      </ul>
    </ForYouItem>
  )
}
